"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEnableCodingListQuery = exports.useDisableCodingListQuery = exports.useSetCodingEntryState = exports.useSaveProviderFieldsQuery = exports.useGetProviderFieldsQuery = exports.useDeleteProviderMappingQuery = exports.useSaveProviderMappingQuery = exports.useGetProviderMappingQuery = exports.useToggleCodingListEntryQuery = exports.useChangeCodingListEntryIdQuery = exports.useSaveCodingListEntryQuery = exports.useDeleteCodingListEntryQuery = exports.useGetInactiveCodingListEntriesQuery = exports.getCodingListsEntriesQuery = exports.useDeleteCodingListQuery = exports.useUpdateCodingListQuery = exports.getCodingListsQuery = void 0;
const react_query_1 = require("@tanstack/react-query");
const lodash_1 = __importDefault(require("lodash"));
const codingRepository_1 = __importDefault(require("../repositories/codingRepository"));
const Root_1 = require("../router/Root");
const companyQuery_1 = require("./companyQuery");
const query_keys_1 = require("./query-keys");
const getCodingListsQuery = ({ skipDisabled }) => (0, react_query_1.queryOptions)({
    queryKey: [query_keys_1.codingKeys.getCodingLists, skipDisabled],
    queryFn: () => codingRepository_1.default.getCodingLists({ skipDisabled }),
});
exports.getCodingListsQuery = getCodingListsQuery;
const useUpdateCodingListQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.saveCodingList,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingLists],
            });
        },
    });
};
exports.useUpdateCodingListQuery = useUpdateCodingListQuery;
const useDeleteCodingListQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.deleteCodingList,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingLists],
            });
        },
    });
};
exports.useDeleteCodingListQuery = useDeleteCodingListQuery;
const getCodingListsEntriesQuery = ({ codingLists }) => {
    return (0, react_query_1.queryOptions)({
        queryKey: [query_keys_1.codingKeys.getCodingListsEntries, codingLists],
        queryFn: () => {
            return Array.isArray(codingLists)
                ? Promise.all(codingLists.map(async (codingList) => {
                    const codingListEntries = await codingRepository_1.default.getCodingListEntries({ codingListCode: codingList?.ID });
                    return {
                        code: codingList?.ID,
                        values: codingListEntries,
                    };
                }))
                : [];
        },
        enabled: Array.isArray(codingLists),
    });
};
exports.getCodingListsEntriesQuery = getCodingListsEntriesQuery;
const useGetInactiveCodingListEntriesQuery = company => (0, react_query_1.useQuery)({
    queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries, company.companyId],
    queryFn: () => codingRepository_1.default.getInactiveCodingListEntries({ companyId: company.companyId }),
    enabled: !!lodash_1.default.get(company, 'companyId'),
});
exports.useGetInactiveCodingListEntriesQuery = useGetInactiveCodingListEntriesQuery;
const useDeleteCodingListEntryQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.deleteCodingListEntry,
        onSuccess: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingLists],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingListsEntries],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries],
            });
        },
    });
};
exports.useDeleteCodingListEntryQuery = useDeleteCodingListEntryQuery;
const useSaveCodingListEntryQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: ({ codingListCode, codingEntryId, codingEntryLabel, }) => codingRepository_1.default.saveCodingListEntry({ codingListCode, codingEntryId, codingEntryLabel }),
        onSuccess: async () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingLists],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingListsEntries],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries],
            });
        },
    });
};
exports.useSaveCodingListEntryQuery = useSaveCodingListEntryQuery;
const useChangeCodingListEntryIdQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: ({ codingListCode, codingEntryId, newCodingEntryId, codingEntryLabel, }) => codingRepository_1.default.changeCodingListEntryId({
            codingListCode,
            codingEntryId,
            newCodingEntryId,
            codingEntryLabel,
        }),
        onSettled: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingLists],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getCodingListsEntries],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries],
            });
        },
    });
};
exports.useChangeCodingListEntryIdQuery = useChangeCodingListEntryIdQuery;
const useToggleCodingListEntryQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: ({ codingListCode, codingEntryId, teamId, state }) => codingRepository_1.default.toggleCodingListEntry({ codingListCode, codingEntryId, teamId, state }),
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries],
            });
        },
    });
};
exports.useToggleCodingListEntryQuery = useToggleCodingListEntryQuery;
const useGetProviderMappingQuery = () => (0, react_query_1.useQuery)({
    queryKey: [query_keys_1.codingKeys.getProviderMapping],
    queryFn: () => codingRepository_1.default.getProviderMapping(),
});
exports.useGetProviderMappingQuery = useGetProviderMappingQuery;
const useSaveProviderMappingQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.setProviderMapping,
        onSuccess: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getProviderMapping],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: companyQuery_1.companyKeys.getFeatures(),
            });
        },
    });
};
exports.useSaveProviderMappingQuery = useSaveProviderMappingQuery;
const useDeleteProviderMappingQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.deleteProviderMapping,
        onSuccess: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getProviderMapping],
            });
            void Root_1.queryClient.invalidateQueries({
                queryKey: companyQuery_1.companyKeys.getFeatures(),
            });
        },
    });
};
exports.useDeleteProviderMappingQuery = useDeleteProviderMappingQuery;
const useGetProviderFieldsQuery = () => (0, react_query_1.useQuery)({ queryKey: [query_keys_1.codingKeys.getProviderFields], queryFn: () => codingRepository_1.default.getProviderFields() });
exports.useGetProviderFieldsQuery = useGetProviderFieldsQuery;
const useSaveProviderFieldsQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.saveProviderFields,
        onSuccess: () => {
            void Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getProviderFields],
            });
        },
    });
};
exports.useSaveProviderFieldsQuery = useSaveProviderFieldsQuery;
const useSetCodingEntryState = () => {
    // TODO: this looks unused do we need it ?
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.setCodingEntryState,
        onSuccess: () => {
            return Root_1.queryClient.invalidateQueries({
                queryKey: [query_keys_1.codingKeys.getInactiveCodingListEntries],
            });
        },
    });
};
exports.useSetCodingEntryState = useSetCodingEntryState;
const useDisableCodingListQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.disableCodingList,
        onSettled: () => {
            void Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.codingKeys.getCodingLists, false] });
        },
    });
};
exports.useDisableCodingListQuery = useDisableCodingListQuery;
const useEnableCodingListQuery = () => {
    return (0, react_query_1.useMutation)({
        mutationFn: codingRepository_1.default.enableCodingList,
        onSettled: () => {
            void Root_1.queryClient.invalidateQueries({ queryKey: [query_keys_1.codingKeys.getCodingLists, false] });
        },
    });
};
exports.useEnableCodingListQuery = useEnableCodingListQuery;
